import React, { useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useField } from '@unform/core';

import { Container, Wrapper } from './styles';
import { toast } from 'react-toastify';

interface Props {
  name: string;
  type?: string;
  disabled?: boolean;
}

interface InputRefProps extends HTMLInputElement {
  acceptedFiles: File[];
}

export default function ReactDropzoneInput({
  name,
  type,
  disabled = false,
}: Props) {
  const inputRef = useRef<InputRefProps>(null);
  const { fieldName, registerField, defaultValue = [], error } = useField(name);

  const [acceptedFiles, setAcceptedFiles] = useState<File[]>(
    Array.isArray(defaultValue) ? defaultValue : [],
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    disabled,
    accept:
      type === 'mxf'
        ? {
            'application/mxf': ['.mxf'],
          }
        : {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'],
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
              '.docx',
            ],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
              '.xlsx',
            ],
          },
    onDropRejected: () => {
      toast.error('Arquivo não permitido');
    },
    onDrop: onDropAcceptedFiles => {
      if (disabled) return;

      if (inputRef.current) {
        inputRef.current.acceptedFiles = onDropAcceptedFiles;
        setAcceptedFiles(onDropAcceptedFiles);
      }
    },
  });

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: (ref: InputRefProps) => {
        return ref.acceptedFiles || [];
      },
      clearValue: (ref: InputRefProps) => {
        ref.acceptedFiles = [];
        setAcceptedFiles([]);
      },
      setValue: (ref: InputRefProps, value) => {
        const files = Array.isArray(value) ? value : [];
        ref.acceptedFiles = files;
        setAcceptedFiles(files);
      },
    });
  }, [fieldName, registerField]);

  return (
    <Wrapper>
      <Container
        isErrored={!!error}
        isDragActive={isDragActive}
        {...getRootProps()}
        onClick={event => {
          if (disabled) {
            event.preventDefault();
            return;
          }
          inputRef.current?.click();
        }}
      >
        <input
          {...getInputProps()}
          // accept="application/pdf, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ref={inputRef}
        />
        {acceptedFiles.length !== 0 && (
          <ul>
            {acceptedFiles.map(file => (
              <li key={file.name}>{file.name}</li>
            ))}
          </ul>
        )}

        {isDragActive ? (
          <p>Solte os arquivos aqui ...</p>
        ) : (
          <p>
            Arraste e solte o arquivo aqui ou clique para selecionar o arquivo
          </p>
        )}
      </Container>
      {!!error && <span>{error}</span>}
    </Wrapper>
  );
}
